import DownloadIcon from '@/common/assets/icons/DownloadIconWithoutBg.svg?react';
import CameraIcon from '@/common/assets/icons/simpleDocumentCameraIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import FlowGuideImage from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/flow-guide.png';
import TakePhotoChassisGuideModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/flowGuide/TakePhotoChassisGuideModal';
import TakePhotoGuideModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/flowGuide/TakePhotoGuideModal';
import { getVehicleModelQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleModel/getVehicleModelQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default () => {
  const navigate = useNavigate();
  const { id, damagedId } = useParams();

  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
      backwardHandler={() => {
        navigate(
          ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
            id: id!,
            damagedId: damagedId!,
          }).ADJUSTER_VEHICLE.damagedPoints,
          { replace: true },
        );
      }}
    >
      <FlowGuidePage />
    </MainLayout>
  );
};

const FlowGuidePage = () => {
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const {
    closeModal: closeTakePhotoGuideModal,
    open: TakePhotoGuideModalIsOpen,
    openModal: openTakePhotoGuideModal,
  } = useModal();

  const {
    closeModal: closeTakePhotoChassisGuideModal,
    open: TakePhotoChassisGuideModalIsOpen,
    openModal: openTakePhotoChassisGuideModal,
  } = useModal();

  const { data: vehicleData } = useQuery(
    getVehicleModelQueryOptions({
      id: id!,
      damaged_id: damagedId!,
      participantRoleType: 'damaged',
    }),
  );

  const goToImageFlow = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        id: id!,
        damagedId: damagedId!,
      }).ADJUSTER_VEHICLE.takePhotoFlow,
      { replace: true },
    );
  };

  const vehicleTargetPart =
    vehicleData?.vehicle_type?.name !== 'motorcycle'
      ? 'شماره شاسی'
      : 'شماره تنه';

  return (
    <Box pt="1.5rem">
      <TitleDescription>راهنما</TitleDescription>
      <Box maxW={'176px'} mx="auto" mt={'45px'}>
        <img className={css({ width: '100%' })} src={FlowGuideImage} alt="" />
      </Box>

      <CardButton
        titleProps={{ textStyle: 'b1', color: 'black-1' }}
        cardProps={{
          className: css({ mt: '2rem' }),
          onClick: openTakePhotoGuideModal,
        }}
        renderIcon={() => (
          <CustomIcon backgroundColor="purple-6" height={42} width={42}>
            <CameraIcon stroke={token('colors.purple-primary')} />
          </CustomIcon>
        )}
        hasArrow
        title="راهنمای عکس‌برداری"
      />
      <CardButton
        titleProps={{ textStyle: 'b1', color: 'black-1' }}
        cardProps={{
          className: css({ mt: '1rem' }),
          onClick: openTakePhotoChassisGuideModal,
        }}
        renderIcon={() => (
          <CustomIcon backgroundColor="green-4" height={42} width={42}>
            <DownloadIcon stroke={token('colors.green')} />
          </CustomIcon>
        )}
        hasArrow
        title={`راهنمای عکس‌برداری از ${vehicleTargetPart}`}
      />
      <FixToBottom className={css({ bottom: '1.5rem' })}>
        <Button fullWidth onClick={goToImageFlow}>
          شروع{' '}
        </Button>
      </FixToBottom>
      <TakePhotoGuideModal
        closeModal={closeTakePhotoGuideModal}
        open={TakePhotoGuideModalIsOpen}
        nextStep={goToImageFlow}
      />
      <TakePhotoChassisGuideModal
        closeModal={closeTakePhotoChassisGuideModal}
        open={TakePhotoChassisGuideModalIsOpen}
        nextStep={goToImageFlow}
        fileRole="damaged"
      />
    </Box>
  );
};
